USE_STATE_ARRAY = [{key: '0', value: '禁用'}, {key: '1', value: '正常'}]
DELETE_STATE_ARRAY = [{key: '0', value: '正常'}, {key: '1', value: '已删除'}]
BOOLEAN_ARRAY = [{key: '0', value: '否'},{key: '1', value: '是'}]
TREE_LEVEL_ARRAY = [{key: '1', value: '一级'},{key: '2', value: '二级'},{key: '3', value: '三级'}]
MEMBER_LEVEL_ARRAY = [{key: '1', value: '青铜'},{key: '2', value: '白银'},{key: '3', value: '黄金'},{key: '4', value: '铂金'},{key: '5', value: '钻石'}]
COIN_ARRAY = [{key: '0', value: '收入'},{key: '1', value: '支出'}]
ORDER_TYPE_ARRAY = [{key: '0', value: '充值'},{key: '1', value: '退款'}]
ORDER_CHANNEL_ARRAY = [{key: '0', value: '微信'},{key: '1', value: '支付宝'},{key: '2', value: '银联'}]
USE_ISSUE_ARRAY = [{key: '0', value: '审核中'},{key: '1', value: '通过'},{key: '2', value: '失败'}]
THINKING_PROCESS_ARRAY = [{key: '0', value: '思考中'},{key: '1', value: '完成'},{key: '2', value: '失败'}]
OPEA_ARRAY = [{key: '0', value: '失败'},{key: '1', value: '完成'}]
THINKING_STATE_ARRAY = [{key: '0', value: '等待中'},{key: '1', value: '已完成'}]